import React from 'react'
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, change, reset } from 'redux-form';
import { connectModal } from 'redux-modal';
import { Button, Form, Modal } from 'react-bootstrap';
import * as validators from 'misc/validators';
import { WORDLISTS_EXPORT_MODAL, WORDLISTS_EXPORT_FORM } from 'misc/constants';
import Spinner from 'components/core/Spinner';
import AddonInputGroupField from 'components/core/AddonInputGroupField';
import SelectField from 'components/core/SelectField';
import PureRenderComponent from 'components/core/PureRenderComponent';

class WordListsExportModal extends PureRenderComponent {

  hide = () => {
    this.props.handleHide()
    this.props.reset(WORDLISTS_EXPORT_FORM);
  }

  render() {
    const {
      show,
      options,
      handleSubmit,
      handleExport,
      isLoading
    } = this.props

    return (
      <Modal
        show={show}
        onHide={this.hide}
        animation={true}
        backdrop="static">
        <Form
          noValidate
          autoComplete="off">
          <Modal.Header closeButton>
            <Modal.Title>Export Client WordLists</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Field
              name="name"
              label="Name"
              type="text"
              validate={[
                validators.required,
                validators.maxLength100
              ]}
              addon=".xlsx"
              isRequired={true}
              component={AddonInputGroupField.Labeled} />
            <Field
              name="keys"
              label="Language"
              validate={[
                validators.required,
              ]}
              multi={true}
              closeOnSelect={false}
              isRequired={true}
              options={options}
              component={SelectField.Labeled} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="pull-left"
              bsSize="sm"
              type="button"
              onClick={this.hide}>
              <FontAwesome name="close" className="mr-5" />Close
            </Button>
            <Button
              bsStyle="primary"
              bsSize="sm"
              type="button"
              onClick={handleSubmit(values => handleExport(values))}>
              <FontAwesome name="paper-plane-o" className="mr-5" />Submit
            </Button>
          </Modal.Footer>
          <Spinner isLoading={isLoading} />
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const initialKeys = (
    state.modal &&
    state.modal.WordListsExportModal &&
    state.modal.WordListsExportModal.props &&
    state.modal.WordListsExportModal.props.initialValues &&
    state.modal.WordListsExportModal.props.initialValues.keys
  )
    ? state.modal.WordListsExportModal.props.initialValues.keys
    : null;
  return {
    initialValues: {
      keys: initialKeys
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    change,
    reset,
  }, dispatch)
}


WordListsExportModal = connectModal({
  name: WORDLISTS_EXPORT_MODAL
})(WordListsExportModal);

WordListsExportModal = reduxForm({
  form: WORDLISTS_EXPORT_FORM,
  enableReinitialize: true
})(WordListsExportModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WordListsExportModal);
